export default "./images/survio-3fizY-assets-security-24.svg";